import React, {useState} from 'react'
import {withRouter} from "react-router";
import {Button} from "react-bootstrap";
import {highlight, languages} from "prismjs/components/prism-core";
import Editor from "react-simple-code-editor";

import {DOMAIN_SUFFIX, SOURCE_PRICING} from "../constants";
import HomeHeader from "../components/HomeHeader";
import Footer from "../components/Footer";
import ManageTable from "../components/ManageTable";
import ProPlans from "../components/ProPlans";
import ProFeatures from "../components/ProFeatures/ProFeaturesB";
import text, {SAMPLE_CODE} from './pricing.string';

import './Pricing.css';
import MessageModal from 'components/MessageModal';

export const ManageLiveSites = ({className, lang = 'GB'}) => {
  const strings = text[lang];

  return <div className={`mt-5 ${className}`}>
    <div className="row">
      <div className="col-3 col-md-2">
        <img src="/assets/icons/web-black.svg" height="50px"/>
      </div>
      <div className="col-9 col-md-10">
        <h3 className="bold text-start">{strings.liveSitesTitle}</h3>
        <p className="pricing-desc op-6">{strings.liveSitesDesc}</p>
      </div>
    </div>
    <div className="box-shadow ms-4 me-4 mt-3 d-none d-md-block">
      <ManageTable
        sites={[
          {subdomain: `landingpage-test1${DOMAIN_SUFFIX}`, created: "12-Jan-2020"},
          {subdomain: `landingpage-test2${DOMAIN_SUFFIX}`, created: "14-Jan-2020"},
          {subdomain: "myamazingblog.com", created: "14-Nov-2018"}
        ]}
      />
    </div>
  </div>
}

export const OnlineCodeEditor = ({className}) => {
  const [code, setCode] = useState(SAMPLE_CODE)
  return <div className={className}>
  <div className="row">
    <div className="col-3 col-md-2">
      <img src="/assets/icons/code-black.svg" height="50px"/>
    </div>
    <div className="col-9 col-md-10">
      <h3 className="bold text-start">Edit your files online</h3>
      <p className="pricing-desc op-6">Quickly edit & publish your code with Pro Plus.</p>
    </div>
    <div className="box-shadow box-100 p-3 ms-5 me-5 mt-3 d-none d-md-block">
      <Editor
        value={code}
        onValueChange={(c) => setCode(c)}
        highlight={code => highlight(code, languages.js)}
        padding={10}
        style={{
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: 12,
          background: '#f9f9f9',
          borderRadius: '4px',
          maxHeight: '70vh',
          overflow: "scroll"
        }}
      />
      <Button className="mt-3 float-right" variant="primary">
        Publish
      </Button>
    </div>
  </div>
</div>}

const Pricing = ({ history }) => {
  const strings = text['GB'];

  const urlParams = new URLSearchParams(window.location.search);
  const errorMessage = urlParams.get('error_message');

  return (
    <div className="full-height body-bg">
      <HomeHeader/>
      <div className="container-pricing w-100">
        <div className="w-100">
          <h3 className="bold text-start">Upgrade for more</h3>
          <p className="pricing-desc op-6 mb-5">{strings.desc}</p>
          <ProPlans
            onFreeClick={() => history.push('/')}
            source={SOURCE_PRICING}
          />
          <ProFeatures strings={strings} hideTitle/>
          <OnlineCodeEditor className="mt-5 pt-5" />
          <ManageLiveSites className="mt-5 mb-130 pt-5" lang="GB" />
          <div className="text-start mt-5 mb-130">
            <h3 className="bold">{strings.faqTitle}</h3>
            {strings.faqs.map((q,key) =>
                <div className="m-md-5" key={key}>
                  <h5 className="mt-5 mb-4"><b>{q.q}</b></h5>
                  <p>
                    {q.a}
                  </p>
                </div>
              )}
          </div>
          <div className="m-5 ms-auto me-auto mb-130">
            <h3 className="bold">{strings.ctaTitle}</h3>
            <div className="w-25 m-auto">
              <Button
                className="action-btn"
                variant="warning"
                onClick={() => window.scrollTo(0,400)}
              >
                {strings.ctaBtn}
              </Button>
            </div>
          </div>
        </div>
      </div>
      {errorMessage && <MessageModal show={errorMessage} title="Payment Failed" message={errorMessage} error={errorMessage} handleNeutral={()=>history.push('/pricing')}/>}
      <Footer/>
    </div>)
};

export default withRouter(Pricing);
